import { Dialog, SxProps } from '@mui/material';
import React, { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  open: boolean;
  onClose: () => void;
  sx?: SxProps;
}

export const Modal: React.FC<Props> = ({ children, open, onClose, sx = {} }) => {
  return (
    <Dialog
      open={open}
      sx={sx}
      PaperProps={{
        sx: {
          minWidth: '41.25rem',
          borderRadius: 0,
        }
      }}
      onClose={onClose}
    >
      {children}
    </Dialog>
  );
};
